(() => {
  'use strict';
  function init(root) {
    root.querySelectorAll('[data-uof-product]').forEach(product => {
      if (product.dataset.uofReady) return;
      product.dataset.uofReady = 'true';
      let variants;
      try { variants = JSON.parse(product.querySelector('[data-uof-variants]').textContent); } catch { return; }
      const image = product.querySelector('#UOFMainImage');
      const setImage = (url, alt) => {
        if (!url || !image) return;
        image.src = url;
        image.removeAttribute('srcset');
        if (alt) image.alt = alt;
      };
      product.addEventListener('change', event => {
        if (!event.target.matches('[data-uof-variant]')) return;
        const variant = variants.find(v => String(v.id) === event.target.value);
        if (!variant) return;
        product.querySelector('[data-uof-price]').textContent = variant.price;
        const compare = product.querySelector('[data-uof-compare]');
        compare.textContent = variant.compare;compare.hidden = !variant.onSale;
        const button = product.querySelector('.product-form__submit');
        button.disabled = !variant.available;button.removeAttribute('aria-disabled');
        product.querySelector('[data-uof-add-label]').textContent = variant.available ? (product.dataset.addLabel || 'Add to Basket') : 'Sold out';
        product.querySelector('[data-uof-stock]').textContent = variant.available ? 'Available to order' : 'This variant is currently sold out.';
        const payment = product.querySelector('[data-uof-payment]');if (payment) payment.hidden = !variant.available;
        const quantity = product.querySelector('[data-uof-quantity]');
        quantity.min = variant.min || 1;quantity.step = variant.step || 1;
        if (variant.max != null) quantity.max = variant.max;else quantity.removeAttribute('max');
        quantity.value = quantity.min;
        setImage(variant.image);
        const url = new URL(location.href);url.searchParams.set('variant',variant.id);history.replaceState({},'',url);
      });
      product.dataset.addLabel = product.querySelector('[data-uof-add-label]').textContent.trim() === 'Sold out' ? 'Add to Basket' : product.querySelector('[data-uof-add-label]').textContent.trim();
      product.querySelectorAll('[data-uof-image]').forEach(button => button.addEventListener('click', () => {
        setImage(button.dataset.uofImage,button.dataset.uofAlt);
        product.querySelectorAll('[data-uof-image]').forEach(other => other.setAttribute('aria-pressed',String(other === button)));
      }));
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') document.querySelectorAll('.uof-mobile-menu[open],.uof-categories[open]').forEach(e => {e.open = false;e.querySelector('summary')?.focus();});
  });
  document.addEventListener('click', event => {
    if (!event.target.closest('.uof-categories')) document.querySelectorAll('.uof-categories[open]').forEach(e=>e.open=false);
  });
})();

(() => {
  'use strict';
  function initGallery(root) {
    root.querySelectorAll('[data-uof-product]').forEach(product => {
      const gallery = product.querySelector('.uof-gallery');
      const stage = gallery?.querySelector('.uof-main-image');
      const image = stage?.querySelector('img');
      const photos = Array.from(gallery?.querySelectorAll('[data-uof-image]') || []);
      if (!image || photos.length < 2 || gallery.dataset.navigationReady) return;
      gallery.dataset.navigationReady = 'true';
      const imageKey = url => new URL(url, location.href).pathname;
      const counter = document.createElement('div');
      counter.className = 'uof-photo-counter';
      counter.setAttribute('aria-live', 'polite');
      counter.setAttribute('aria-atomic', 'true');
      const sync = () => {
        const current = photos.findIndex(photo => imageKey(photo.dataset.uofImage) === imageKey(image.src));
        photos.forEach((photo, index) => photo.setAttribute('aria-pressed', String(index === current)));
        counter.textContent = (Math.max(0, current) + 1) + ' / ' + photos.length;
        return current;
      };
      const move = direction => {
        const current = sync();
        photos[(Math.max(0, current) + direction + photos.length) % photos.length].click();
        sync();
      };
      [-1, 1].forEach(direction => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'uof-gallery-arrow uof-gallery-arrow--' + (direction < 0 ? 'previous' : 'next');
        button.setAttribute('aria-label', direction < 0 ? 'Previous photograph' : 'Next photograph');
        button.textContent = direction < 0 ? '‹' : '›';
        button.addEventListener('click', () => move(direction));
        stage.append(button);
      });
      gallery.append(counter);
      image.draggable = false;
      let start = null;
      stage.addEventListener('touchstart', event => {
        start = event.touches.length === 1 ? { x: event.touches[0].clientX, y: event.touches[0].clientY } : null;
      }, { passive: true });
      stage.addEventListener('touchmove', event => {
        if (event.touches.length !== 1) start = null;
      }, { passive: true });
      stage.addEventListener('touchcancel', () => { start = null; }, { passive: true });
      stage.addEventListener('touchend', event => {
        if (!start || event.touches.length || event.changedTouches.length !== 1) { start = null; return; }
        const dx = event.changedTouches[0].clientX - start.x;
        const dy = event.changedTouches[0].clientY - start.y;
        start = null;
        if (Math.abs(dx) >= 45 && Math.abs(dx) > Math.abs(dy) * 1.5) move(dx < 0 ? 1 : -1);
      }, { passive: true });
      const observer = new MutationObserver(sync);
      observer.observe(image, { attributes: true, attributeFilter: ['src'] });
      document.addEventListener('keydown', event => {
        if (!gallery.isConnected) { observer.disconnect(); return; }
        if (event.defaultPrevented || event.altKey || event.ctrlKey || event.metaKey || event.shiftKey || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        if (event.target.closest('input, textarea, select, [contenteditable="true"], dialog, [role="dialog"], .uof-header-shell')) return;
        const bounds = stage.getBoundingClientRect();
        if (bounds.bottom <= 0 || bounds.top >= window.innerHeight) return;
        event.preventDefault();
        move(event.key === 'ArrowRight' ? 1 : -1);
      });
      sync();
    });
  }
  initGallery(document);
  document.addEventListener('shopify:section:load', event => initGallery(event.target));
})();

(function(){
function initCategoryNavigation(){document.querySelectorAll('[data-uof-header]').forEach(function(header){if(header.dataset.categoryNavigationReady)return;header.dataset.categoryNavigationReady='true';var groups=header.querySelectorAll('.uof-nav-group');groups.forEach(function(group){group.addEventListener('toggle',function(){if(group.open)groups.forEach(function(other){if(other!==group)other.open=false;});});});header.querySelectorAll('.uof-desktop-links a,.uof-mobile-links a').forEach(function(link){var target=new URL(link.href,location.href);if(target.pathname===location.pathname&&target.search===location.search){link.setAttribute('aria-current','page');var group=link.closest('.uof-nav-group');if(group)group.setAttribute('data-uof-current','true');}});document.addEventListener('click',function(event){if(!header.contains(event.target))groups.forEach(function(group){group.open=false;});});header.addEventListener('keydown',function(event){if(event.key==='Escape')groups.forEach(function(group){if(group.open){group.open=false;group.querySelector('summary').focus();}});});});}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initCategoryNavigation);else initCategoryNavigation();document.addEventListener('shopify:section:load',initCategoryNavigation);
})();
